import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Lottie from "lottie-react";
import LoadingAnimation from "../../../animations/Loading.json";
import WebsiteAnimation from "../../../animations/LoadingCube.json";

const useStyles = makeStyles(() => ({
  preLoader: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
}));

const PreLoader = () => {
  const classes = useStyles();
  return (
    // @ts-ignore
    <Box className={classes.preLoader}>
      <Box>
        <Lottie animationData={WebsiteAnimation} loop={true} />
      </Box>
    </Box>
  );
};

export default PreLoader;
